<template>
  <div class="results">
    <div class="shadow-divide scroll-border-dom"></div>
    <div class="results-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem><router-link to="/">{{$t('nav.home')}}</router-link></BreadcrumbItem>
        <BreadcrumbItem>{{$t('query.result.other.codeDictQuery')}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="results-content">
        <ListContent ref="content" class="r-main" :dataSet="dataSet" :pageSize="pageSize" :isShowLoader="isShowLoader"></ListContent>
      </div>
    </div>
  </div>
</template>

<script>
import ListContent from './ListContent'

export default {
  name: 'CodeDictQueryList',
  components: { ListContent },
  data () {
    return {
      sidebarMinHeight: 0,
      isShowLoader: false,
      pageSize: 20,
      dataSet: {}
    }
  },
  created () {
    this.requestData({page: 1, size: this.pageSize})
  },
  mounted () {
    this.$nextTick(() => {
      this.setSidebarHeight()
    })
  },
  methods: {
    getData (page, importerID, key) {
      page = page || 1
      if (importerID) {
        this.requestData(this._.assign({page: page}, {size: this.pageSize, importAreaId: importerID, key: key || ''}))
      } else {
        this.requestData(this._.assign({page: page}, {size: this.pageSize, key: key || ''}))
      }
    },
    delayRequestData (data) {
      setTimeout(() => {
        this.requestData(data)
      }, 500)
    },
    requestData (data) {
      if (this.isShowLoader) {
        this.delayRequestData()
        return
      }
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
      this.$api.codeQuery.getList(data, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data)) {
              if (this.$refs.content) {
                this.$refs.content.currentPage = data.page || 1
              }
              this.dataSet = response.data.data
              setTimeout(() => {
                this.setSidebarHeight()
              }, 500)
            } else {
              this.$Message.warning({content: this.$t('query.message.news_none'), closable: true})
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({content: this.$t('query.message.news_none'), closable: true})
          } else if (response.data.code === 505) {
            this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
          } else if (response.data.code === 401) {
            this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
          } else if (response.data.code === 506) {
            this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
            this.$Message.warning({content: response.data.message, closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    setSidebarHeight () {
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      let resultMinHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getOuterElSize(footer).height - 18))
      resultDom.style.minHeight = resultMinHeight + 'px'
    }
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 15px 0 25px;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .ivu-breadcrumb{
    margin: 12px 0 30px;
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .ivu-breadcrumb .ivu-breadcrumb-item-link,
  .ivu-breadcrumb >>> a{
    color: #999;
  }
  .ivu-breadcrumb >>> a:hover{
    color: #1F8AFD;
    text-decoration: none;
    box-shadow: none;
  }
  .ivu-breadcrumb >>> a:after{
    width: 0;
    height: 0;
  }
  .ivu-breadcrumb > span:last-child{
    color: #1F8AFD;
    font-weight: normal;
  }
  .ivu-breadcrumb >>> .ivu-breadcrumb-item-separator{
    margin: 0 2px;
  }
  .results-content{
    position: relative;
    /*padding-left: 245px;*/
  }
  .r-main{}
  /*.r-sidebar{*/
    /*position: absolute;*/
    /*top:0;*/
    /*left: 0;*/
    /*width: 220px;*/
    /*!*height: 100%;*!*/
    /*min-height: 100%;*/
    /*background-color: #fff;*/
    /*border-right: 0.5px solid #E9E9E9;*/
    /*padding-right: 25px;*/
  /*}*/
</style>




// WEBPACK FOOTER //
// src/components/codeQuery/List.vue